import { getPathFromProductUrl } from 'src/app/utilities/url.utils';
import { Product, ProductDto } from './product.model';
import { DealDto } from 'src/app/model/deal.model';
import {
    ProductCardEntry,
    transformDealDtoToProductCardEntry,
} from '@app/controls/product-card/product-card.model';

export interface CategoryProducts {
    data: Array<ProductCardEntry>;
    total: number;
}

export interface CategoryProductsDto {
    bannerData: BannerDataDto;
    category: string;
    data: Array<ProductDto>;
    is_promotion_activated: number | boolean;
    promotion_data: PromotionDataDto;
    promotion_upto: Date;
    stay_advance_search_deal: string;
    total: number;
}

export interface BannerData {
    banner1: Array<Banner>;
    banner2: Array<Banner>;
}

export interface BannerDataDto {
    banner1: Array<BannerDto>;
    banner2: Array<BannerDto>;
}

export interface Banner {
    categoryId: string;
    createdAt: Date;
    filename: string;
    filenameDesktop: string;
    fromDate: Date;
    id: string;
    isProduct: boolean;
    location: string;
    productData: Array<{}>;
    status: string;
    storeIds: string;
    title: string;
    toDate: Date;
    updatedAt: Date;
    urlString: string;
}

export interface BannerDto {
    categoryid: string;
    created_at: Date;
    filename: string;
    filename_desktop: string;
    from_date: Date;
    id: string;
    is_product: boolean;
    location: string;
    product_data: Array<{}>;
    status: string;
    store_ids: string;
    title: string;
    to_date: Date;
    updated_at: Date;
    urlstring: string;
}

export interface PromotionData {
    afterBackgroundImage: string;
    beforeBackgroundImage: string;
    counterBackgroundColor: string;
    counterDigitBackgroundColor: string;
    counterDigitColor: string;
    counterDigitTextColor: string;
    isPromotionActivated: number;
    isPromotionStarted: number;
    promotionEndDate: Date;
    promotionEndDateIos: Date;
    promotionHomepageCategoryColor: number;
    promotionStartDate: Date;
    promotionStartDateIos: Date;
}

export interface PromotionDataDto {
    after_background_image: string;
    before_background_image: string;
    counter_background_color: string;
    counter_digit_background_color: string;
    counter_digit_color: string;
    counter_digit_text_color: string;
    is_promotion_activated: number;
    is_promotion_started: number;
    promotion_end_date: Date;
    promotion_end_date_ios: Date;
    promotion_homepage_category_color: number;
    promotion_start_date: Date;
    promotion_start_date_ios: Date;
}

export const transformProductListDtoToCategoryProducts = (
    raw: ProductListDto
): CategoryProducts => {
    return {
        data: raw.deals.map((deal) => transformDealDtoToProductCardEntry(deal)),
        total: raw.totalHits,
    } as CategoryProducts;
};

export interface ProductListDto {
    totalHits: number;
    deals: DealDto[];
}
